import { render, staticRenderFns } from "./ComProduct.vue?vue&type=template&id=2e892d51&scoped=true"
import script from "./ComProduct.vue?vue&type=script&lang=js"
export * from "./ComProduct.vue?vue&type=script&lang=js"
import style0 from "./ComProduct.vue?vue&type=style&index=0&id=2e892d51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e892d51",
  null
  
)

export default component.exports